import React from 'react'
import HandleMarkup from '@src/components/HandleMarkup'
import { useUserSession } from '@src/utils/useUserSession'
import { getLocalizedUrl } from '@src/utils/regional'
import { DocumentLink } from '@src/types/graphql-types'
import { sendDownloadFileEvent } from '@src/utils/analytics'

const isAnchorTagProperlyFormatted = (anchorTag: string): boolean =>
  !!anchorTag.match(/<a.*?href/i)

const isPDF = (anchorTag: string): boolean => !!anchorTag.match(/.pdf/i)
const isXLSX = (anchorTag: string): boolean => !!anchorTag.match(/.xlsx/i)

interface ItemProps {
  country: string
  language: string
  link: DocumentLink
  section: string
  productNumber: string
}

const Item: React.FC<ItemProps> = ({ link, section, productNumber }) => {
  const { userSession } = useUserSession()
  const isFandFLink =
    link.anchorTag &&
    link.anchorTag.includes('/certificates/flavors-and-fragrances')
  let markup = ''
  const isClient = typeof window !== 'undefined'
  if (isFandFLink && isClient) {
    const linkContent =
      isAnchorTagProperlyFormatted(link.anchorTag) && link.anchorTag
    const tempElement = document.createElement('div') as HTMLDivElement
    tempElement.innerHTML = linkContent.toString()
    const linkElement = tempElement.getElementsByTagName(
      'a'
    )[0] as HTMLAnchorElement
    const initURL = linkElement.href
    const url = new URL(initURL)
    const localizedURL = getLocalizedUrl(userSession, url.pathname)
    linkElement.href = localizedURL.as
    markup = linkElement.outerHTML
    tempElement.remove()
  } else {
    markup = isAnchorTagProperlyFormatted(link.anchorTag)
      ? link.anchorTag
      : isPDF(link.anchorTag) || isXLSX(link.anchorTag)
        ? `<a href="${
            link.anchorTag
          }" target="_blank" data-dlname="${link.anchorTag.substring(
            link.anchorTag.lastIndexOf('/') + 1
          )}" data-event="download" data-dltype="${section}">${link.label}</a>`
        : `<a href="${link.anchorTag}">${link.label}</a>`
  }
  const handleClick = () => {
    if (isPDF(link.anchorTag)) {
      sendDownloadFileEvent(
        {
          action: 'more documents',
        },
        {
          component: 'body',
          elementType: 'link',
          linkText: link.label,
          linkUrl: link.anchorTag,
          fileCategory: section,
          productId: productNumber,
        }
      )
    }
  }

  return (
    <div onClick={handleClick}>
      <HandleMarkup value={markup} />
    </div>
  )
}

export default Item
